// src/pages/Home.jsx

import React from "react";
import Header from "../components/layout/Header";
import Services from "./Services";
import Contact from "./Contact";
import "../assets/styles/global.css";

function Home() {
  return (
    <>
      <Header />

      <main className="home-container">
        <section className="hero-section">
          <h1>Flexotec Maria</h1>
          <p>طباعة أكياس نايلون – أكياس ورقية – خدمات مطاعم  </p>
          <a href="#contact" className="cta-btn">اطلب عرض سعر</a>
        </section>

        <Services />
        <Contact />
      </main>
    </>
  );
}

export default Home;
